import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import tokenManager from "../utils/tokenManager";

const GoogleCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get token from URL query params
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        const error = params.get("error");

        if (error) {
          navigate("/login?error=google_auth_failed");
          return;
        }

        if (token) {
          tokenManager.setTokens(token);

          // Fetch user data
          const response = await fetch(
            `${
              process.env.REACT_APP_API_URL || "http://localhost:5000/api"
            }/auth/me`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            tokenManager.setUser(data.user);

            // Check if onboarding is complete
            if (!data.user.company?.workspaceUrl) {
              navigate("/onboarding");
            } else {
              navigate("/dashboard");
            }
          } else {
            navigate("/login?error=google_auth_failed");
          }
        } else {
          navigate("/login?error=google_auth_failed");
        }
      } catch (error) {
        console.error("Google auth error:", error);
        navigate("/login?error=google_auth_failed");
      }
    };

    handleCallback();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#0C0E12] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-gray-800 rounded-lg flex items-center justify-center mx-auto mb-6">
          <Loader2 className="animate-spin h-8 w-8 text-purple-500" />
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">
          Completing sign in...
        </h2>
        <p className="text-gray-400">Please wait while we redirect you.</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
